import { createActionGroup, emptyProps, props } from '@ngrx/store';

import * as fromGenerated from '../../_generated';

export const ChatModalActions = createActionGroup({
  source: 'ChatModal',
  events: {
    'Open Delete Chat Modal': emptyProps(),
    'Close Delete Chat Modal': emptyProps(),
  },
});

export const ChatActions = createActionGroup({
  source: 'Chat',
  events: {
    'Select Chat': props<{
      id: number;
      navigateToRequest?: boolean;
    }>(),
    'Unselect Chat': emptyProps(),
    'Toggle Loading': props<{
      isLoading: boolean;
    }>(),
    'Select Empty Chat': emptyProps(),
    'Load Empty Chat': emptyProps(),
    'Load Empty Chat Success': props<{ chat: fromGenerated.ChatView }>(),
    'Load Empty Chat Failure': props<{ error: string }>(),
    'Open Side Container': emptyProps(),
    'Close Side Container': emptyProps(),
    'Open Threads Listing Container': emptyProps(),
    'Close Threads Listing Container': emptyProps(),
    'Delete Chat Success': props<{ id: number }>(),
    'Delete Chat Failure': props<{ error: string }>(),
    'Delete Many Chats Success': props<{ ids: number[] }>(),
  },
});

export const ChatsActions = createActionGroup({
  source: 'Chats',
  events: {
    'Load Chats': emptyProps(),
    'Load Chats Success': props<{ chats: fromGenerated.ChatView[] }>(),
    'Load Chats Failure': props<{ error: string }>(),
    'Delete Chat': props<{
      id: number;
    }>(),
    'Delete Chats': emptyProps(),
    'Delete Chats Success': emptyProps(),
    'Delete Chats Failure': props<{ error: string }>(),
  },
});

export const ChatWithMessagesActions = createActionGroup({
  source: 'ChatWithMessages',
  events: {
    'Load ChatWithMessages': props<{
      id: number;
    }>(),
    'Load ChatWithMessages Success': props<{
      chatWithMessages: fromGenerated.ChatWithMessagesView;
    }>(),
    'Load ChatWithMessages Failure': props<{ error: string }>(),
    'Add ChatMessage': props<{
      chatId: number;
      content: string;
    }>(),
    'Add ChatMessage Success': emptyProps(),
    'Add ChatMessage Failure': props<{ chatId: number; error: string }>(),
    'Received ChatWithMessages from Socket Success': props<{
      chatWithMessages: fromGenerated.ChatWithMessagesView;
    }>(),
    'Received ChatWithMessages from Socket Failure': props<{
      chatWithMessages: fromGenerated.ChatWithMessagesView;
      errorCode: string;
    }>(),
  },
});

export const ChatsSocketActions = createActionGroup({
  source: 'ChatsSocket',
  events: {
    Reconnect: emptyProps(),
  },
});
